import * as less from './RadioPlayer.less';
import React from 'react';
import Immutable from 'immutable';
import classnames from 'classnames';
import moment from 'moment';
import { Link, Navigation } from 'react-router';

const BaseRadioPlayerClass = React.createClass({
  mixins: [Navigation],

  render: function baseRender() {
    return <div></div>;
  }
});

export default class App extends BaseRadioPlayerClass {
  constructor(props, context) {
    super(props, context);

    this.onPlayClick = this.onPlayClick.bind(this);
    this.onNextClick = this.onNextClick.bind(this);
    this.onShareClick = this.onShareClick.bind(this);
    this.onNavigationClick = this.onNavigationClick.bind(this);
    this.onSubNavigationClick = this.onSubNavigationClick.bind(this);
    this.onPlayRandomClick = this.onPlayRandomClick.bind(this);
    this.onAudioEnded = this.onAudioEnded.bind(this);
    this.onAudioTimeUpdated = this.onAudioTimeUpdated.bind(this);
    this.onAudioCanPlay = this.onAudioCanPlay.bind(this);

    this.state = {
      hideMenu: false,
      hideSubMenu: true,
      hideShareMenu: true
    };
  }

  onPlayRandomClick(e) {
    e.preventDefault();

    if (this.props.playlist.isPlaying) { return; }

    this.props.actions.play();
  }

  onNextClick(e) {
    e.preventDefault();

    this.props.actions.next();
  }

  onPlayClick(e) {
    e.preventDefault();

    if (this.props.playlist.isPlaying) {
      this.props.actions.stop();
    } else {
      this.props.actions.play();
    }
  }

  onNavigationClick(e) {
    e.preventDefault();

    this.setState({ hideMenu: !this.state.hideMenu, hideShareMenu: true, hideSubMenu: true });
  }

  onSubNavigationClick(e) {
    e.preventDefault();

    this.setState({ hideSubMenu: !this.state.hideSubMenu });
  }

  onShareClick(e) {
    e.preventDefault();

    this.setState({ hideShareMenu: !this.state.hideShareMenu, hideMenu: true, hideSubMenu: true });
  }

  createOnLabelClick(key) {
    return (e) => {
      e.preventDefault();

      this.transitionTo('labels', { labelId: key });
    };
  }

  createOnNavigateToClick(routeNameOrPath, params, query) {
    return (e) => {
      e.preventDefault();

      /*this.setState({
        hideMenu: true,
        hideSubMenu: true,
        hideShareMenu: true
      });*/

      this.transitionTo(routeNameOrPath, params, query);
    };
  }

  onAudioTimeUpdated(e) {
    const currentTime = React.findDOMNode(this.refs.audio).currentTime;
    this.props.actions.updateCurrentTime(currentTime);
  }

  onAudioEnded() {
    const audio = React.findDOMNode(this.refs.audio);
    audio.removeEventListener('ended', this.onAudioEnded);
    audio.removeEventListener('timeupdate', this.onAudioTimeUpdated);

    this.props.actions.next();
  }

  onAudioCanPlay() {
    const audio = React.findDOMNode(this.refs.audio);
    audio.addEventListener('ended', this.onAudioEnded);
    audio.addEventListener('timeupdate', this.onAudioTimeUpdated);

    audio.currentTime = this.props.playlist.position.time;
    audio.play();
  }

  componentDidMount() {
    const audio = React.findDOMNode(this.refs.audio);
    audio.addEventListener('canplay', this.onAudioCanPlay);
  }

  componentWillUnmount() {
    const audio = React.findDOMNode(this.refs.audio);
    audio.removeEventListener('canplay', this.onAudioCanPlay);
  }

  componentDidUpdate(prevProps, prevState) {
    const shouldStartPlaying = this.props.playlist.isPlaying && this.props.playlist.isPlaying !== prevProps.playlist.isPlaying;
    const startPlayingNextSong = this.props.playlist.isPlaying && this.props.playlist.isPlaying === prevProps.playlist.isPlaying && this.props.playlist.position.index !== prevProps.playlist.position.index;

    if (shouldStartPlaying || startPlayingNextSong) {
      const audio = React.findDOMNode(this.refs.audio);

      audio.load();
    }
  }

  leftPad(number, targetLength) {
    let output = number + '';

    while (output.length < targetLength) {
        output = '0' + output;
    }

    return output;
  }

  getTimeString(duration) {
    const timeCode = moment.duration(duration, 'seconds');
    return `${this.leftPad(timeCode.hours(), 2)}:${this.leftPad(timeCode.minutes(), 2)}:${this.leftPad(timeCode.seconds(), 2)}`;
  }

  render() {
    const playlist = this.props.playlist;
    const currentSong = playlist.getCurrentSong();
    const duration = playlist.getDuration();
    const shareUrl = encodeURIComponent(document.location.href);

    let shareText = 'Radio—Kangol';

    if (currentSong && playlist.isPlaying) {
      shareText = `${playlist.playlist.title} now on air at Radio Kangol`;
    }

    shareText = encodeURIComponent(shareText);

    const twitterShareLink = `https://twitter.com/share?text=${shareText}&url=${shareUrl}`;
    const facebookShareLink = `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`;
    const googleShareLink = `https://plus.google.com/share?url=${shareUrl}`;

    let audioSrc = null;
    let currentPercent = 0;
    let currentTimeString = '00:00:00';
    let durationTimeString = '00:00:00';
    let audioTitle = <span className='audio-title'>Radio Kangol</span>;
    let audioLink = null;
    let audioSeparator = null;
    let audioTitleSeparator = <span>&nbsp;&nbsp;-&nbsp;&nbsp;</span>;
    let playlistTitle = '';
    let audioSubTitle = <span className='audio-sub-title'><a href='#' onClick={this.onPlayRandomClick}>Play random station</a></span>;
    let shareInfo = null;

    if (duration) {
      durationTimeString = this.getTimeString(duration);
    }

    if (currentSong && playlist.isPlaying) {
      audioSrc = currentSong.src;
    }

    if (currentSong) {// && playlist.isPlaying) {
      const totalPlayed = playlist.getTotalTimePlayed();
      currentPercent = Math.min(totalPlayed / duration, 1);
      currentTimeString = this.getTimeString(totalPlayed);

      audioTitle = <span className='audio-title'>{currentSong.title}</span>;
      playlistTitle = <a href='#' onClick={this.createOnLabelClick(this.props.playlist.playlist.key)}>{playlist.playlist.title}</a>;
      if (currentSong.purchase) {
        let audioUrl = currentSong.purchase;
        if (audioUrl.length > 0) {
          audioSeparator = <span>&nbsp;/&nbsp;</span>;
          audioLink = <span className='audio-sub-title'><a href={audioUrl} target='_blank'>Buy Track</a></span>;
        }
      }
      if (currentSong.artist) {
        audioSubTitle = <span className='audio-sub-title'>{currentSong.artist}{audioSeparator}</span>;
      } else {
        audioTitleSeparator = null;
        audioSubTitle = null;
      }

      shareInfo = <div className='share-info'>
        <a href='#' className='share-btn' onClick={this.onShareClick}>Share</a>
      </div>;
    }

    const progressBarStyle = {
      width: (currentPercent * 100) + '%'
    };

    const playBtnClassNames = classnames('text-hide', {
      'btn-play': !playlist.isPlaying,
      'btn-stop': playlist.isPlaying
    });

    const navigationBarClassNames = classnames('navigation-bar', {
      'display-hidden': this.state.hideMenu
    });

    const shareBarClassNames = classnames('navigation-bar', {
      'display-hidden': this.state.hideShareMenu
    });

    const navigationClassNames = classnames('navigation-button', {
      'navigation-hidden': this.state.hideMenu
    });

    const subNavigationBarClassNames = classnames('sub-navigation-bar', {
      'display-hidden': this.state.hideSubMenu
    });

    const subNavigationClassNames = classnames('sub-navigation-hidden', {
      hide: this.state.hideSubMenu
    });

    // <li><a href='#' onClick={this.onNextClick}>Next</a></li>
    return <div className='radio-player'>
      <div className={navigationBarClassNames}>
        <div className={subNavigationBarClassNames}>
          <ul className='list-inline navigation-list'>
            <li><a href='#' onClick={this.createOnNavigateToClick('labels', { labelId: 'burger' })}>Burger</a></li>
            <li><a href='#' onClick={this.createOnNavigateToClick('labels', { labelId: 'foundation' })}>Foundation</a></li>
            <li><a href='#' onClick={this.createOnNavigateToClick('labels', { labelId: 'golf-channel' })}>Golf Channel</a></li>
            <li><a href='#' onClick={this.createOnNavigateToClick('labels', { labelId: 'minimal-wave' })}>Minimal Wave</a></li>
            <li><a href='#' onClick={this.createOnNavigateToClick('labels', { labelId: 'plant' })}>Plant Records</a></li>
            <li><a href='#' onClick={this.createOnNavigateToClick('labels', { labelId: 'ppu' })}>PPU</a></li>
            <li><a href='#' onClick={this.createOnNavigateToClick('labels', { labelId: 'rockers' })}>Rockers</a></li>
            <li><a href='#' onClick={this.createOnNavigateToClick('labels', { labelId: 'soundway' })}>Soundway</a></li>
            <li><a href='#' onClick={this.createOnNavigateToClick('labels', { labelId: 'stones-throw' })}>Stones Throw</a></li>
            <li><a href='#' onClick={this.createOnNavigateToClick('labels', { labelId: 'workshop' })}>Workshop</a></li>
          </ul>
        </div>
        <ul className='list-inline navigation-list'>
          <li><a href='#' onClick={this.createOnNavigateToClick('shows')}>Shows</a></li>
          <li>
            <a href='#' onClick={this.onSubNavigationClick}>
              Labels
              <span className={subNavigationClassNames}></span>
            </a>
          </li>
          <li><a href='#' onClick={this.createOnNavigateToClick('shop')}>Shop</a></li>
          <li><a href='#' onClick={this.createOnNavigateToClick('about')}>About</a></li>
        </ul>
      </div>
      <div className={shareBarClassNames}>
        <ul className='list-inline navigation-list share-list'>
          <li className='pull-right'><a className="share-google" target="_blank" href={googleShareLink}>Google</a></li>
          <li className='pull-right'><a className="share-facebook" target="_blank" href={facebookShareLink}>Facebook</a></li>
          <li className='pull-right'><a className="share-twitter" target="_blank" href={twitterShareLink}>Twitter</a></li>
        </ul>
      </div>
      <div className='radio-controls'>
        <div className='navigation-info'>
          <a href='#' className={navigationClassNames} onClick={this.onNavigationClick}>Menu</a>
        </div>
        <div className='playlist-info'>
          <span className='playlist-title'>{playlistTitle}</span>
        </div>
        {shareInfo}
        <div className='audio-info'>
          {audioTitle}
          {audioTitleSeparator}
          {audioSubTitle}
          {audioLink}
        </div>
        <div className='audio-logo'>
          <Link to='shows'>Radio-Kangol</Link>
        </div>
        <a className={playBtnClassNames} href='#' onClick={this.onPlayClick}>Play</a>
        <div className='time-code-current'>{currentTimeString}</div>
        <div className='time-code-duration'>{durationTimeString}</div>
        <div className='progress'>
          <div className='progress-bar' style={progressBarStyle}>
            <div className='progress-bar-head'></div>
          </div>
        </div>
        <div className='audio-file'>
          <audio ref='audio' src={audioSrc} hidden='hidden'></audio>
        </div>
      </div>
    </div>;
  }
}

App.propTypes = {
  playlist: React.PropTypes.object,
  actions: React.PropTypes.object
};


/** WEBPACK FOOTER **
 ** ./src/components/RadioPlayer.jsx
 **/